export const getAllList = (state, todoListValues, totalList) => {
  return {
    ...state,
    timelineTodoList: [...state.timelineTodoList, ...todoListValues],
    total: totalList,
  };
};

export const setLoader = (state, loaderValue) => {
  return {
    ...state,
    isLoading: loaderValue
  }
}

export const updateList = (state, list) => {
  const listCopy = [...state.timelineTodoList];

  listCopy[
    listCopy.findIndex((tList) => {
      return tList.id === list.id;
    })
  ] = {
    ...list,
  };

  return {
    ...state,
    timelineTodoList: listCopy,
  };
};

export const createList = (state, list) => {
  var newTimelineTodoList = Array.from(new Set([list, ...state.timelineTodoList]));

  return {
    ...state,
    total: state.total + 1,
    timelineTodoList: newTimelineTodoList,
  };
};

export const pageIncreament = (state) => {
  var newPage = state.page + 1;

  return {
    ...state,
    page: newPage,
  };
};

export const clearAll = () => {
  return {
    timelineTodoList: [],
    total: "",
    page: 1,
    isLoading: true,
  };
};
